import React, { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { Tabs } from '@sede-enterprise/shell-ds-react-framework';
import { MessagingContainer } from './style';
import { NUMBERS } from '../../../constants/Common';

const renderRouteLabel = (label: string, route: string) => (
  <a
    href={route}
    onClick={(event) => event.preventDefault()}
    style={{ color: 'inherit', textDecoration: 'none' }}
  >
    {label}
  </a>
);

const Messaging = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<string>('inbox');

  useEffect(() => {
    const pathSegments = location.pathname.split('/');
    const subTab = pathSegments[NUMBERS.THREE] || 'inbox';
    setActiveTab(subTab);
  }, [location]);

  const handleTabChange = (tabKey: string) => {
    setActiveTab(tabKey);
    navigate(`/new-genesis/messaging/${tabKey}`);
  };

  const tabs = [
    {
      key: 'inbox',
      label: renderRouteLabel('Internal Inbox', '/new-genesis/messaging/inbox'),
    },
    {
      key: 'external-inbox',
      label: renderRouteLabel('External Inbox', '/new-genesis/messaging/external-inbox'),
    },
  ];

  return (
    <MessagingContainer>
      <Tabs className='sub-tab' activeKey={activeTab} onChange={handleTabChange} items={tabs} />
      <div className='content'>
        <Outlet />
      </div>
    </MessagingContainer>
  );
};

export default Messaging;
